import { Box, styled } from '@mui/material';

const Container = styled(Box)`
  display: flex;
  gap: 16px;
  flex-direction: column;
`;

export default Container;
